import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaB2bTariffModem',
			dom: {
				price: '.js-b2b-tariff-modem-price',
				radio: '.js-b2b-tariff-modem-radio',
				tabs: '.js-b2b-tariff-modem-tabs',
				region: '.js-b2b-tariff-modem-region',
				sppedin: '.js-b2b-tariff-modem-sppedin',
				sppedout: '.js-b2b-tariff-modem-sppedout'
			},
			classes: {
				once: 'b-b2b-tariff-modem_type_once',
				global: 'b-b2b-tariff-modem_state_global',
				tab: 'b-b2b-tariff-modem__tab_state_active'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.data = {};
		this.type = false;
		this.subtype = false;
		this.isOnce = false;
		return this;
	}

	getDom() {
		this.$price = this.$el.find(this.options.dom.price);
		if (!this.isOnce) {
			this.$radio = this.$el.find(this.options.dom.radio);
			this.$region = this.$el.find(this.options.dom.region);
			this.$sppedin = this.$el.find(this.options.dom.sppedin);
			this.$sppedout = this.$el.find(this.options.dom.sppedout);
		}
		this.$tabs = this.$el.find(this.options.dom.tabs);
		return this;
	}

	tab(event) {
		const $target = $(event.currentTarget);
		this.$tabs.removeClass(this.options.classes.tab);
		$target.addClass(this.options.classes.tab);
		this.getData();
		return this;
	}

	getData() {
		if (this.isOnce) {
			this.type = this.$tabs.filter('.' + this.options.classes.tab).data('js');
			this.subtype = this.$el.data('subtype');
		} else {
			this.subtype = this.$tabs.filter('.' + this.options.classes.tab).data('js');
			this.type = this.$radio.filter(':checked').val();
			this.$el.toggleClass(this.options.classes.global, this.subtype === 'global');
		}
		this.$price.html(this.data[this.subtype][this.type]);
		this.$window.trigger('yota.b2b.modem.change', [{type: this.type, subtype: this.subtype}]);
		return this;
	}

	render() {
		if (this.$el.length) {
			this.isOnce = this.$el.hasClass(this.options.classes.once);
			if (yotaPortlets.b2bTariffModem) {
				this.data = yotaPortlets.b2bTariffModem;
				this.getDom();
				this.getData();

				if (!this.isOnce) {
					this.$radio.on('change', this.getData.bind(this));
					if (this.data.regionName) {
						this.$region.html(this.data.regionName.replace(/-/g, '&#8209;'));
					}
					if (this.data.limit) {
						this.$sppedin.html(this.data.limit['in']);
						this.$sppedout.html(this.data.limit['out']);
					}
				}
				this.$tabs.on('click', this.tab.bind(this));

			} else {
				console.error('The b2bTariffModem portlet has no data, set data to "yotaPortlets.b2bTariffModem"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/b2b-tariff-modem/b2b-tariff-modem.js